import { QueryClient } from '@tanstack/vue-query'
import { ApiError } from './api'

/**
 * App-wide TanStack Query client. Configured for the admin dashboard's
 * read-heavy workload:
 *  * 30s staleTime for lists — frequent enough for a dashboard, not
 *    so frequent that paginating triggers a refetch storm.
 *  * No retry on 4xx — those are user / programmer errors, not
 *    transients.
 *  * One retry on 5xx + network, with a 1s backoff.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false
        }
        return failureCount < 1
      },
      retryDelay: 1_000,
    },
    mutations: {
      // Mutations never auto-retry — let the UI surface failures.
      retry: false,
    },
  },
})
